import {useMemo} from "react";
import {Colors} from "@brg/ui";
import {AppTester} from "../../supporting";

export const useGetSelectedTagColor = (isFolder: boolean) => {

    const isGeo = AppTester.isGeograffee();
    const isHseDesign = AppTester.isHSEDesign();
    const isMedia = AppTester.isMediiia();
    const isDvaDesign = AppTester.isDvaDesign();
    const isGeoDafes = AppTester.isGeoDafes();
    const isGreenAward = AppTester.isGreenAward();
    
    const blueBG = useMemo(() => isMedia || isHseDesign, [isHseDesign, isMedia])
    const greenBG = useMemo(() => isGeo && !isGeoDafes, [isGeo, isGeoDafes])
    const redBG = useMemo(() => !blueBG && !greenBG && !isGeoDafes, [blueBG, greenBG, isGeoDafes])
    
    const selectedColor = useMemo(() => (
        isFolder ? {
            text: {
                default: Colors.geoWhite100,
                hover: Colors.geoWhite100,
                disabled: Colors.geoWhite100,
            },
            fill: {
                default: '#29894E',
                hover: '#29894E',
                disabled: '#F00',
            },
        } : isGreenAward ? {
            text: {
                default: Colors.geoWhite100,
                hover: Colors.geoWhite100,
                disabled: Colors.geoWhite100,
            },
            fill: {
                default: '#89B644',
                hover: '#89B644',
                disabled: '#89B644',
            },
        }: isDvaDesign
            ? {
                text: {
                    default: Colors.geoWhite100,
                    hover: Colors.geoWhite100,
                    disabled: Colors.geoWhite100,
                },
                fill: {
                    default: '#0C32EF',
                    hover: '#092ACD',
                    disabled: '#0C32EF',
                },
            }
            : blueBG ? {
                    text: {
                        default: Colors.geoWhite100,
                        hover: Colors.geoWhite100,
                        disabled: Colors.geoWhite100,
                    },
                    fill: {
                        default: '#146DEE',
                        hover: '#0A56C4',
                        disabled: '#146DEE',
                    },
                } :
                greenBG ? {
                        text: {
                            default: Colors.geoWhite100,
                            hover: Colors.geoWhite100,
                            disabled: Colors.geoWhite100,
                        },
                        fill: {
                            default: '#A4B54D',
                            hover: '#AAB862',
                            disabled: '#A4B54D',
                        },
                    } :
                    redBG ? {
                            text: {
                                default: Colors.geoWhite100,
                                hover: Colors.geoWhite100,
                                disabled: Colors.geoWhite100,
                            },
                            fill: {
                                default: '#F00',
                                hover: '#F00',
                                disabled: '#F00',
                            },
                        } :
                        isGeoDafes ? {
                                text: {
                                    default: Colors.geoWhite100,
                                    hover: Colors.geoWhite100,
                                    disabled: Colors.geoWhite100,
                                },
                                fill: {
                                    default: '#E75728',
                                    hover: '#D24010',
                                    disabled: '#E75728',
                                },
                            } :
                            {
                                text: {
                                    default: Colors.geoWhite100,
                                    hover: Colors.geoWhite100,
                                    disabled: Colors.geoWhite100,
                                },
                                fill: {
                                    default: '#F00',
                                    hover: '#F00',
                                    disabled: '#F00',
                                },
                            }
    ), [isDvaDesign, blueBG, greenBG, redBG, isGeoDafes])
    
    return selectedColor
}import {useMemo} from "react";
import {Colors} from "@brg/ui";
import {AppTester} from "../../supporting";

export const useGetSelectedTagColor = (isFolder: boolean) => {

    const isGeo = AppTester.isGeograffee();
    const isHseDesign = AppTester.isHSEDesign();
    const isMedia = AppTester.isMediiia();
    const isDvaDesign = AppTester.isDvaDesign();
    const isGeoDafes = AppTester.isGeoDafes();
    const isGreenAward = AppTester.isGreenAward();
    
    const blueBG = useMemo(() => isMedia || isHseDesign, [isHseDesign, isMedia])
    const greenBG = useMemo(() => isGeo && !isGeoDafes, [isGeo, isGeoDafes])
    const redBG = useMemo(() => !blueBG && !greenBG && !isGeoDafes, [blueBG, greenBG, isGeoDafes])
    
    const selectedColor = useMemo(() => (
        isFolder ? {
            text: {
                default: Colors.geoWhite100,
                hover: Colors.geoWhite100,
                disabled: Colors.geoWhite100,
            },
            fill: {
                default: '#29894E',
                hover: '#29894E',
                disabled: '#F00',
            },
        } : isGreenAward ? {
            text: {
                default: Colors.geoWhite100,
                hover: Colors.geoWhite100,
                disabled: Colors.geoWhite100,
            },
            fill: {
                default: '#89B644',
                hover: '#89B644',
                disabled: '#89B644',
            },
        }: isDvaDesign
            ? {
                text: {
                    default: Colors.geoWhite100,
                    hover: Colors.geoWhite100,
                    disabled: Colors.geoWhite100,
                },
                fill: {
                    default: '#0C32EF',
                    hover: '#092ACD',
                    disabled: '#0C32EF',
                },
            }
            : blueBG ? {
                    text: {
                        default: Colors.geoWhite100,
                        hover: Colors.geoWhite100,
                        disabled: Colors.geoWhite100,
                    },
                    fill: {
                        default: '#146DEE',
                        hover: '#0A56C4',
                        disabled: '#146DEE',
                    },
                } :
                greenBG ? {
                        text: {
                            default: Colors.geoWhite100,
                            hover: Colors.geoWhite100,
                            disabled: Colors.geoWhite100,
                        },
                        fill: {
                            default: '#A4B54D',
                            hover: '#AAB862',
                            disabled: '#A4B54D',
                        },
                    } :
                    redBG ? {
                            text: {
                                default: Colors.geoWhite100,
                                hover: Colors.geoWhite100,
                                disabled: Colors.geoWhite100,
                            },
                            fill: {
                                default: '#F00',
                                hover: '#F00',
                                disabled: '#F00',
                            },
                        } :
                        isGeoDafes ? {
                                text: {
                                    default: Colors.geoWhite100,
                                    hover: Colors.geoWhite100,
                                    disabled: Colors.geoWhite100,
                                },
                                fill: {
                                    default: '#E75728',
                                    hover: '#D24010',
                                    disabled: '#E75728',
                                },
                            } :
                            {
                                text: {
                                    default: Colors.geoWhite100,
                                    hover: Colors.geoWhite100,
                                    disabled: Colors.geoWhite100,
                                },
                                fill: {
                                    default: '#F00',
                                    hover: '#F00',
                                    disabled: '#F00',
                                },
                            }
    ), [isDvaDesign, blueBG, greenBG, redBG, isGeoDafes])
    
    return selectedColor
}